/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { languageCodeSchema } from '../../languages/language-code-schema';

export const updatePreferencesBodySchema = z.object({
  primaryLanguage: languageCodeSchema.nullable(),
});

export type IUpdatePreferencesBody = z.infer<typeof updatePreferencesBodySchema>;
